import axios from "axios";
import config from "../config";

//全局设置axios的请求头
axios.defaults.headers.post["Content-Type"] = "application/json";
//允许携带session
axios.defaults.withCredentials = true;
axios.defaults.timeout = 600000;
//创建axios实例
const request = axios.create({
    baseURL: config.Request_URL,
    timeout: 600000,
});

//请求拦截器
request.interceptors.request.use(
    config => {
        if (localStorage.getItem("AUTH_TOKEN")) {
            config.headers['Authorization'] = localStorage.getItem("AUTH_TOKEN")
        }
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data'
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

//响应拦截器
request.interceptors.response.use(
    res => {
        return res.data
    },
    err => {
        return Promise.reject(err)
    }
)
export default request;
